var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-content',{staticClass:"success",attrs:{"grow":true,"blue":true,"center":true}},[_c('i',{staticClass:"fa-duotone fa-party-horn"}),_c('h1',[_vm._v("Awesome - we can't wait to see what you do!")]),_c('p',[_vm._v("We will approve your account within 48 hours, so keep an eye on your emails!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }